import type { VerifyEmailConfirmResponse } from "@gull/shared";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Alert, Button, Layout, Spin, Typography } from "antd";
import { useAuth } from "../lib/auth";
import { enduserApi, ApiError } from "../lib/api";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

type Status = "idle" | "verifying" | "ok" | "error";

export default function VerifyEmail() {
  const { user, loading, signInWithVipps } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState<Status>("idle");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (loading || !user || !token || status !== "idle") return;
    setStatus("verifying");
    (async () => {
      try {
        await enduserApi.authedPost<VerifyEmailConfirmResponse>("/me/email/verify-confirm", {
          token,
        });
        setStatus("ok");
      } catch (err) {
        setError(err instanceof ApiError ? err.message : "Ukjent feil");
        setStatus("error");
      }
    })();
  }, [user, loading, token, status]);

  return (
    <Content style={{ maxWidth: 560, margin: "64px auto", padding: 24 }}>
      <Title level={2}>Bekreft e-post</Title>
      {!token ? (
        <Alert type="error" showIcon message="Mangler bekreftelseslenke" />
      ) : loading || status === "verifying" ? (
        <Spin />
      ) : !user ? (
        <>
          <Paragraph>Logg inn for å fullføre bekreftelsen.</Paragraph>
          <Button className="vipps-button" type="primary" onClick={signInWithVipps}>
            Logg inn med Vipps
          </Button>
        </>
      ) : status === "ok" ? (
        <>
          <Alert type="success" showIcon message="E-postadressen er bekreftet" />
          <Paragraph style={{ marginTop: 16 }}>
            <Link to="/min-side">Gå til min side</Link>
          </Paragraph>
        </>
      ) : status === "error" ? (
        <Alert type="error" showIcon message={error ?? "Lenken er ugyldig eller utløpt"} />
      ) : null}
    </Content>
  );
}
